export interface JoliooPharmacy {
  id: string;
  name: string;
  pharmacy_number: string;
  /** Freigeschaltet fuer Gutscheine. ⚠ Fehlt sie, gilt die Apotheke als
   *  teilnehmend — aeltere CMS-Staende lieferten nur freigeschaltete. */
  enabled?: boolean;
}

export interface JoliooVoucher {
  code: string;
  serial: string | null;
  title: string | null;
  state: string | null;
  value: number | null;
  value_current: number | null;
  value_reserved: number | null;
  currency_id: number | null;
  customer_product_id: number | null;
}

/**
 * Antwort von /check. Die Historie reist mit, damit das Öffnen des Verlaufs
 * keinen weiteren Jolioo-Aufruf kostet.
 */
export interface JoliooCheckResponse extends JoliooVoucher {
  history: Array<JoliooHistoryEntry>;
}

export interface JoliooReservation {
  delta_id: number | null;
  reserved_value: number | null;
  voucher: JoliooVoucher;
}

export interface JoliooRedemption {
  delta_id: number | null;
  value: number | null;
  state: string | null;
  time: string | null;
  voucher: JoliooVoucher;
}

export interface JoliooHistoryEntry {
  history_type: string;
  history_time: string;
  /** Eingelöster Betrag, immer positiv — das CMS liefert nur Abbuchungen. */
  history_delta_value: number;
}

export const VOUCHER_STATE = {
  VALID: "valid",
  INVALIDATED: "invalidated",
  CANCELED: "canceled",
  EXPIRED: "expired",
  RESERVED: "reserved",
} as const;
